import { DistanceUnit, TemperatureUnit } from 'Components/NormalizationSettings/configs';

export type NumberConstraints = {
  min: number;
  max: number;
};

export const meterToFeet = (meters: number) => meters * 3.28084;
export const feetToMeter = (feet: number) => feet / 3.28084;

export const celsiusToFahrenheit = (celsius: number) => celsius * 1.8 + 32;
export const fahrenheitToCelsius = (fahrenheit: number) => (fahrenheit - 32) / 1.8;

export const convertDistance = (
  value: number | null,
  { sourceUnit, targetUnit }: { sourceUnit: DistanceUnit; targetUnit: DistanceUnit }
) => {
  if (value === null) {
    return value;
  }
  if (sourceUnit === targetUnit) {
    return value;
  }
  if (targetUnit === DistanceUnit.Feet) {
    return Math.round(meterToFeet(value));
  }
  return Math.round(feetToMeter(value));
};

export const convertTemperature = (
  value: number,
  { sourceUnit, targetUnit }: { sourceUnit: TemperatureUnit; targetUnit: TemperatureUnit }
) => {
  if (sourceUnit === targetUnit) {
    return value;
  }
  if (targetUnit === TemperatureUnit.Fahrenheit) {
    return Math.round(celsiusToFahrenheit(value));
  }
  return Math.round(fahrenheitToCelsius(value));
};
